import { useQuery } from "@tanstack/react-query";
import { fetchRegistryMaterials, type RegistryMaterial } from "@/integrations/agreements/client";
import { useAuthContext } from "@/components/AuthProvider";

/**
 * Catálogo de resíduos do musa-agreements. O nome do hook ficou do tempo em que a lista vinha
 * por um gateway GraphQL; os consumidores não mudaram.
 *
 * `enabled: false` evita a busca em tela que não mostra o filtro.
 */
export function useGatewayMaterials(options: { enabled?: boolean } = {}) {
  const { profile } = useAuthContext();

  return useQuery<RegistryMaterial[]>({
    queryKey: ["registry-materials"],
    queryFn: fetchRegistryMaterials,
    enabled: !!profile && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
